
import { useDispatch } from 'react-redux';

import { useTypedSelector } from '../../../hooks/useTypeSelector';

import { FlyerEditorLeftMenu } from './leftMenu/FlyerEditorLeftMenu'
import { FlyerEditorContent } from './rightContent/FlyerEditorContent'

import './FlyerPromoItemsEditor.scss'
import { savePagePromoItemsData } from '../../../store/actionCreators/flippingFlyerActionCreators';
import {useEffect, useState} from "react";
import {ActionType} from "../../../store/actionTypes";
import {setSelectedPageForTabs} from "../../../store/actionCreators/pagesActionCreators";
import {
    addEventDataTypeListener,
    EVENT_DATA_TYPE_OPEN_PAGES_FLYER,
    removeEventTypeListener
} from "../../../globals/EventDispatcher";
import {CustomDataEvent} from "../../../globals/CustomDataEvent";
import {clearFlyersData} from "../../../store/actionCreators/flyersActionCreators";

export const FlyerPromoItemsEditor = () => {

    // let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    let flayerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const flyersState = useTypedSelector((state) => state.flyers);


    const dispatch = useDispatch();


    const [isOpenPagesTab, openPagesTab] = useState<boolean>(false);

    useEffect(() => {
        if(flyersState.type === ActionType.CHANGE_FLYERS_STATE){
            if(isOpenPagesTab){
                try {
                    const data = {
                        pageNo: 0,
                        selectedTabNum: 1
                    }
                    dispatch(setSelectedPageForTabs(data));
                } catch (e) {

                }
            }
        }
    }, [flyersState])
    useEffect(() => {
        addEventDataTypeListener(EVENT_DATA_TYPE_OPEN_PAGES_FLYER, (data: CustomDataEvent) => {
            openPagesTab(data.data);
        })

        return () => {
            dispatch(clearFlyersData());
            removeEventTypeListener(EVENT_DATA_TYPE_OPEN_PAGES_FLYER);
        }

    }, []);



    const onSpotsFileSelected = (file: File) => {
        let flyerDto = flayerDetailsState!;
        dispatch(savePagePromoItemsData(flyerDto.flyRecId!, file, flyerDto.flyLacRec!.lacCode!));
        // let flyerDto = flippingFlyerState.flyerDto!
        // dispatch(savePagePromoItemsData(flyerDto.flyRecId!, file, flyerDto.flyLacRec!.lacCode!));
    }

    return (
        <div className="flyer_promo_items_editor_container">
            <FlyerEditorLeftMenu 
                onSpotsFileSelected={onSpotsFileSelected}
            />
            <FlyerEditorContent data={flayerDetailsState}/>
            {/*<FlyerEditorContent data={flippingFlyerState.flyerDto}/>*/}
        </div>
    )
}